<template>
  <section class="column">
    <div class="voucher-wrapper">
      <div
        class="voucher-header"
        v-bind:style="{ backgroundColor: box.boxColor, color: box.boxText }"
      >
        <div
          class="voucher-redeem-overlay"
          v-if="checkCookieValue(box.id) || alreadyRedeemed(box.redeem)"
        ></div>
        <div class="voucherImageBox">
          <img v-bind:src="box.iconImage" />
          <div
            class="voucher-redeem-overlay"
            v-if="checkCookieValue(box.id) || alreadyRedeemed(box.redeem)"
          >
            <v-icon
              class="voucher-redeem-icon"
              name="times"
              scale="10"
            ></v-icon>
          </div>
        </div>
        <link
          v-if="customFonts.customFonts"
          :href="customFonts.customFontUrl"
          rel="stylesheet"
        />
        <div v-if="isSecLangActive">
          <span
            class="box-title-custom"
            v-if="customFonts.customFonts"
            :style="{
              'font-family': customFonts.customFontCss,
              'font-size': customFonts.customFontSize,
            }"
            >{{ box.titleSec }}</span
          >
          <h4 class="voucher-title" v-else>{{ box.titleSec }}</h4>
        </div>
        <div v-else>
          <span
            class="box-title-custom"
            v-if="customFonts.customFonts"
            :style="{
              'font-family': customFonts.customFontCss,
              'font-size': customFonts.customFontSize,
            }"
            >{{ box.title }}</span
          >
          <h4 class="voucher-title" v-else>{{ box.title }}</h4>
        </div>
      </div>
      <div
        class="voucher-footer"
        v-bind:style="{ backgroundColor: box.boxColor, color: box.boxText }"
      >
        <div
          class="voucher-redeem-overlay"
          v-if="checkCookieValue(box.id) || alreadyRedeemed(box.redeem)"
        ></div>
        <div
          class="voucher-footer-text"
          v-if="
            confirmVoucher !== box.id &&
            !checkCookieValue(box.id) &&
            !alreadyRedeemed(box.redeem)
          "
        >
          <p v-if="isSecLangActive">{{ box.textSec }}</p>
          <p v-else>{{ box.text }}</p>
        </div>
        <button
          v-bind:style="{
            backgroundColor: box.btnColor,
            color: box.btnTextColor,
          }"
          v-on:click="confirmVoucher = box.id"
          class="gbBtn voucher-redeem"
          v-if="
            confirmVoucher !== box.id &&
            !checkCookieValue(box.id) &&
            !alreadyRedeemed(box.redeem)
          "
        >
          <span>{{ isSecLangActive ? box.buttonSec : box.button }}</span>
        </button>
        <button
          v-bind:style="{
            backgroundColor: box.btnColor,
            color: box.btnTextColor,
          }"
          v-on:click="confirmVoucher = null"
          class="gbBtn voucher-cancel"
          v-if="
            confirmVoucher == box.id &&
            !checkCookieValue(box.id) &&
            !alreadyRedeemed(box.redeem)
          "
        >
          <v-icon name="arrow-left" scale="1.5" />
        </button>
        <button
          v-bind:style="{
            backgroundColor: box.btnColor,
            color: box.btnTextColor,
          }"
          v-on:click="redeem(box)"
          class="gbBtn voucher-confirm"
          v-if="
            confirmVoucher == box.id &&
            !checkCookieValue(box.id) &&
            !alreadyRedeemed(box.redeem)
          "
        >
          <span>{{
            isSecLangActive ? box.buttonConfirmSec : box.buttonConfirm
          }}</span>
        </button>
        <div
          v-if="
            isRedeemed == box.id ||
            checkCookieValue(box.id) ||
            alreadyRedeemed(box.redeem)
          "
        >
          <p v-if="isSecLangActive">{{ box.textSec }}</p>
          <p v-else>{{ box.text }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import cookieMixin from "../../mixins/cookieMixin";
import "../../vue-awesome-icons";
import { redeemVoucher } from "../../callables";

export default {
  props: {
    box: Object,
    customFonts: Object,
    activeLanguage: String,
    cookieExists: [String],
    secondLang: Boolean,
  },
  mixins: [cookieMixin],
  computed: {
    isSecLangActive() {
      return this.secondLang && this.cookieExists;
    },
  },
  data() {
    return {
      activeGuestTemp: "",
      confirmVoucher: null,
      isRedeemed: null,
    };
  },
  mounted() {
    this.activeGuestTemp = sessionStorage.getItem("activeGuestTemp");
  },
  methods: {
    alreadyRedeemed(redeemArray) {
      return redeemArray.includes(this.activeGuestTemp);
    },
    async redeem(box) {
      this.isRedeemed = box.id;
      this.setCookie(box.id, true, 10);

      if (
        !this.alreadyRedeemed(box.redeem) &&
        this.activeGuestTemp &&
        this.activeGuestTemp !== "unknownID"
      ) {
        await redeemVoucher({
          hotelID: this.$hotelId,
          voucherID: box.id,
          guestID: this.activeGuestTemp,
        });
      } else {
        await redeemVoucher({
          hotelID: this.$hotelId,
          voucherID: box.id,
        });
      }
    },
  },
};
</script>
<style scoped>
.column {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  background-repeat: no-repeat;
  background-position: center;
  width: 100%;
  height: 100%;
  border-radius: 8px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.25);
}
.box-title-custom {
  margin-top: 10px;
  margin-bottom: 5px;
  display: block;
  font-size: 2.5em;
  line-height: 1;
}
.gbBtn {
  height: 45px;
  padding: 0px 9px;
  margin-bottom: 13px;
  border: 2px solid transparent;
  width: calc(100% - 26px);
  border-radius: 8px;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.25);
  overflow-x: hidden;
  font-family: "Poppins", sans-serif;
  font-weight: 400;
  cursor: pointer;
}

.voucherImageBox {
  position: relative;
  width: 100%;
  max-height: 100px;
  overflow: hidden;
  margin: 0 auto;
  border-radius: 8px 8px 0px 0px;
}
.voucherImageBox > img {
  width: 100%;
  height: 100px;
  object-fit: cover;
}
.voucher-redeem-overlay {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: #e8e8e8;
  opacity: 0.5;
  top: 0;
}
.voucher-redeem-icon {
  height: 100%;
  color: #000000;
}
.voucher-footer {
  position: relative;
  height: 80px;
  padding: 0 5px;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.voucher-footer-text {
  font-size: 13px;
  text-align: left;
  width: 65%;
}
.voucher-header {
  position: relative;
  height: 160px;
  border-bottom: dashed;
  border-width: 1px;
  border-radius: 8px;
}
.voucher-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  overflow-x: hidden;
}
.voucher-wrapper .voucher-redeem {
  margin-bottom: 0px;
  width: 30%;
}
.voucher-wrapper .voucher-confirm {
  margin-bottom: 0px;
  width: 68%;
}
.voucher-wrapper .voucher-cancel {
  margin-bottom: 0px;
  width: 22%;
}
.voucher-redeemed {
  font-size: 14px;
  width: 90%;
  border-radius: 8px;
  padding: 14px;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.25);
}
.voucher-redeemed > p {
  margin: 0;
}

.voucher-title {
  font-size: 1.25rem;
  font-weight: 500; /* Medium */
  margin-top: 20px;
}
</style>
